import { render, staticRenderFns } from "./TaxInvoices.vue?vue&type=template&id=5b2c4130&scoped=true&"
import script from "./TaxInvoices.vue?vue&type=script&lang=js&"
export * from "./TaxInvoices.vue?vue&type=script&lang=js&"
import style0 from "./TaxInvoices.vue?vue&type=style&index=0&id=5b2c4130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c4130",
  null
  
)

export default component.exports